import * as Sentry from "@sentry/react";
import React from "react";
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes
} from "react-router-dom";
import { logger } from "./utils/logger";
import { ApplicationMode } from "./Interfaces";

/**
 * Initializes Sentry SDK.
 * @param {ApplicationMode} mode The current application mode.
 * @param {string|undefined} dsn The Sentry DSN to use for error tracking.
 * @returns {void}
 */
export const initializeSentry = (mode: ApplicationMode, dsn: string | undefined): void => {
    logger.info(`Attempting to initialize Sentry for ${mode} mode.`);

    if (!dsn) {
        logger.warn("Sentry DSN is not provided. Sentry will not be initialized.");
        return;
    }

    Sentry.init({
        dsn: dsn,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            }),
        ],
        tracesSampleRate: 1.0,
        environment: mode,
        release: APP_VERSION,
        sendDefaultPii: true,
        normalizeDepth: 5,
    });
}
